//if (document.cookie.indexOf("OptanonAlertBoxClosed=") >= 0) {
//    window.dataLayer = window.dataLayer || [];
//    window.dataLayer.push({
//        'event': 'OnetrustGroupsUpdated',
//        'OptanonAlertBoxClosed': 'true'
//    });
//}
//else {
//    window.dataLayer = window.dataLayer || [];
//    window.dataLayer.push({
//        'event': 'OnetrustGroupsUpdated',
//        'OptanonAlertBoxClosed': 'false'
//    });
//}
function optanonRefresher() {
    if (OnetrustActiveGroups === '' || OnetrustActiveGroups === null) return;
    //videos
    if (OnetrustActiveGroups.includes(',C0003,')) {
        var elems = document.querySelectorAll('.optanon-category-C0003');
        for (var i = 0; i < elems.length; i++) {
            var e = elems[i];
            var ifr = e.querySelector('iframe[data-src]');
            if (ifr) {
                ifr.src = ifr.dataset.src;
                ifr.removeAttribute('data-src');
            }
            else if (e.hasAttribute('type') && e.getAttribute('type') === 'text/plain' && e.hasAttribute('src') && e.getAttribute('src') !== null) {
                var scrpt = document.createElement('script');
                scrpt.src = e.getAttribute('src');
                scrpt.type = 'text/javascript';
                //document.getElementsByTagName("head")[0].removeChild(scrpt);
                document.getElementsByTagName("head")[0].appendChild(scrpt);
            }
        }
    }
}